export default "/bundles/assets/photo2_751e51d41445fe2f92a2ac2c54401e57.png";